import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Card } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";
import Layout from "../../../layout/fullpage";
import { Logo, Media, MediaGroup, Image } from "../../../components";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const SmsOtpReset = () => {
    const [step, setStep] = useState(1);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [otp, setOtp] = useState('');
    const [password, setPassword] = useState('');
    const [cPassword, setCPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const navigate = useNavigate(); // Make sure this is declared at the top inside your component

    const handleSendOtp = async () => {
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_HOST}api/password/sms/send-otp`,
                {},
                {
                    params: { phone_number: phoneNumber }
                }
            );

            if (res.data.success) {
                Swal.fire({
                    imageUrl: "/shop/images/Success2.svg",
                    imageWidth: '100%',
                    imageHeight: 'auto',
                    imageAlt: "Success Image",
                    title: 'Success',
                    text: res.data.message,
                    timer: 3000, // Auto close after 3 seconds
                    timerProgressBar: true,
                    showConfirmButton: false, // Hide the "OK" button
                });
                setStep(2);
            }
        } catch (err) {
            Swal.fire('Error', err.response?.data?.message || 'Failed to send OTP', 'error');
        }
    };

    const handleVerifyOtp = async () => {
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_HOST}api/password/sms/verify-otp`,
                {},
                {
                    params: {
                        phone_number: phoneNumber,
                        otp,
                        password,
                        c_password: cPassword
                    }
                }
            );

            Swal.fire({
                imageUrl: "/shop/images/Success2.svg",
                imageWidth: '100%',
                imageHeight: 'auto',
                imageAlt: "Success Image",
                title: 'Success',
                text: res.data.message,
                timer: 3000, // Auto close in 3 seconds
                timerProgressBar: true,
                showConfirmButton: false
            }).then(() => {
                // Auto-redirect after Swal closes
                navigate('/shop/auths/login');
            });


            setStep(1);
            setPhoneNumber('');
            setOtp('');
            setPassword('');
            setCPassword('');
        } catch (err) {
            Swal.fire('Error', err.response?.data?.message || 'Failed to verify OTP', 'error');
        }
    };
    return (
        <Layout title="Reset Password via SMS" centered>
            <div className="container p-2 p-sm-6">
                <Card className="overflow-hidden card-gutter-lg rounded-4 card-auth card-auth-mh">
                    <Row className="g-0 flex-column flex-lg-row">
                        <Col lg="7" className="d-block p-0 mobile-image-container">
                            <Card.Body
                                className="h-100 d-flex flex-column justify-content-center p-0"
                                style={{
                                    backgroundImage: "url('/shop/images/Forgot-Password.svg')",
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    backgroundRepeat: "no-repeat",
                                    minHeight: "35vh" // 35% of viewport height on mobile
                                }}
                            />
                        </Col>
                        <Col lg="5" className="order-lg-2">
                            <Card.Body className="h-100 d-flex flex-column justify-content-center">
                                <div className="nk-block-head text-center">
                                    <div className="text-center">
                                        <img
                                            src="/shop/images/elite-main1.png"
                                            className="custom-image"
                                            alt="Centered logo"
                                            style={{ width: "30%", backgroundColor: "rgb(255, 255, 255)", marginBottom: "10px" }}
                                        />
                                    </div>
                                    <h3 className="nk-block-title mb-1">Reset Password</h3>
                                    <p className="small">Use your mobile number to reset your password.</p>
                                </div>

                                <h4 className="text-center mb-4">Reset Password via SMS</h4>

                                {step === 1 && (
                                    <>
                                        <div className="mb-3">
                                            <label className="form-label">Enter Mobile Number</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={phoneNumber}
                                                onChange={(e) => setPhoneNumber(e.target.value)}
                                                placeholder="Enter 10-digit number"
                                            />
                                        </div>
                                        <button className="btn btn-primary w-100" onClick={handleSendOtp}>
                                            Send OTP
                                        </button>
                                    </>
                                )}

                                {step === 2 && (
                                    <>
                                        <div className="mb-3">
                                            <label className="form-label">Mobile Number</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={phoneNumber}
                                                readOnly
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label">Enter OTP</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={otp}
                                                onChange={(e) => setOtp(e.target.value)}
                                                placeholder="6-digit OTP"
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label">New Password</label>
                                            <div className="position-relative">
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    className="form-control pe-5"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                />
                                                <span
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    style={{
                                                        position: "absolute",
                                                        right: "15px",
                                                        top: "50%",
                                                        transform: "translateY(-50%)",
                                                        cursor: "pointer",
                                                        color: "#6c757d"
                                                    }}
                                                >
                                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label">Confirm Password</label>
                                            <div className="position-relative">
                                                <input
                                                    type={showConfirmPassword ? "text" : "password"}
                                                    className="form-control pe-5"
                                                    value={cPassword}
                                                    onChange={(e) => setCPassword(e.target.value)}
                                                />
                                                <span
                                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                    style={{
                                                        position: "absolute",
                                                        right: "15px",
                                                        top: "50%",
                                                        transform: "translateY(-50%)",
                                                        cursor: "pointer",
                                                        color: "#6c757d"
                                                    }}
                                                >
                                                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                                </span>
                                            </div>
                                        </div>

                                        <button className="btn btn-primary w-100" onClick={handleVerifyOtp}>
                                            Verify OTP & Reset Password
                                        </button>
                                    </>
                                )}
                            </Card.Body>
                        </Col>

                        {/* Right Side - Welcome Section */}

                    </Row>
                </Card>
            </div>
            {/* Add custom CSS for mobile view */}
            <style jsx>{`
        /* Hide browser's default password reveal button */
        input::-ms-reveal,
        input::-ms-clear {
          display: none;
        }
        input::-webkit-credentials-auto-fill-button {
          display: none !important;
        }
        @media (max-width: 991.98px) {
          .mobile-image-container {
            height: 35vh !important;
          }
          .mobile-form-container {
            height: 55vh !important;
            overflow-y: auto;
          }
          .card-auth-mh {
            min-height: 90vh !important;
          }
        }
      `}</style>
        </Layout>
    );
};

export default SmsOtpReset;
